export default __webpack_public_path__ + "static/media/Rock.b8e36871.png";